export const SITE_URL = true ? "https://stiletto-bo.com" : "http://localhost:3000";
export const API_URL = true ? 'https://api.stiletto-bo.com/api' : 'http://localhost:5000/api';